import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';
import fs from 'fs';

import queries from '../../../utils/queries'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

import HomeUser1 from './homeuser1';
import HomeUser2 from './homeuser2';

import UserAut1 from './useraut1';
import UserAut2 from './useraut2';
import AddAut1 from './addaut1';
import AddAut2 from './addaut2';
import VerAut1 from './veraut1';
import VerAut2 from './veraut2';

import UserPerfil1 from './userperfil1';
import UserPerfil2 from './userperfil2';
import AddPerfil1 from './addperfil1';
import AddPerfil2 from './addperfil2';
import VerPerfil1 from './verperfil1';
import VerPerfil2 from './verperfil2';

import UserAutP1 from './userautp1';
import UserAutP2 from './userautp2';

import UserUsu1 from './userusu1';
import UserUsu2 from './userusu2';
import AddUsu1 from './addusu1';
import AddUsu2 from './addusu2';
import VerUsu1 from './verusu1';
import VerUsu2 from './verusu2';

import CambClave1 from './cambclave1';
import CambClave2 from './cambclave2';
import CargUsu1 from './cargusu1';
import CargUsu2 from './cargusu2';

class HomeUser extends React.Component{
  state={
    showUser: true, showUpdUsu: false,
    showAutorizac: false, addAutorizac: false, verAutorizac: false,
    showPerfil: false, addPerfil: false, verPerfil: false,
    showUsu: false, addUsu: false, verUsu: false,
    showCambClave: false, showAutPerfil: false,
    permiteUpdate: false, permiteDelete: false,
    argsAdd: {}, errorAdd: [],
    idLista: {},
    lisAutPerfil: [], lisAut: [], lisAutPerfilIni: [], lisAutIni: [],
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];
    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }

    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  showUser = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showUser: true})
  }

  showUpdUsu = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showUpdUsu: true})
  }

  showAutorizac = (ev) => {
    ev.preventDefault()
    this.props.allAutorizac.refetch()
    this.estadosFalse()
    this.setState({showAutorizac: true})
  }

  showPerfil = (ev) => {
    ev.preventDefault()
    this.props.allPerfiles.refetch()
    this.estadosFalse()
    this.setState({showPerfil: true})
  }

  showUsu = (ev) => {
    ev.preventDefault()
    this.props.allUsuarios.refetch()
    this.estadosFalse()
    this.setState({showUsu: true})
  }

  showCambClave = (ev) => {
    ev.preventDefault()
    this.props.allUsuarios.refetch()
    this.estadosFalse()
    this.setState({showCambClave: true})
  }

  showAutPerfil = (ev) => {
    ev.preventDefault()
    this.props.allPerfiles.refetch()
    this.estadosFalse()
    this.setState({showAutPerfil: true})

    let lisAutPerfil = [];
    let lisAutPerfilIni = []
    let elemento2 = this.state.idLista.autorizac
    elemento2.forEach((elemento, i) => {
      lisAutPerfil.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
        _id: i, estadoAut: true});

      lisAutPerfilIni.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
        _id: i, estadoAut: true});
      })
      lisAutPerfil = _.orderBy(lisAutPerfil, ['codigoAutorizac'])
    // this.ordenarArrayAsc(lisAutPerfil, 'codigoAutorizac')
    this.setState({lisAutPerfil})

    lisAutPerfilIni = _.orderBy(lisAutPerfilIni, ['codigoAutorizac'])
    // this.ordenarArrayAsc(lisAutPerfilIni, 'codigoAutorizac')
    this.setState({lisAutPerfilIni})

    const lisAut = [];
    const lisAutIni = [];
    elemento2 = this.props.allAutorizac.allAutorizac
    elemento2.forEach((elemento, _id) => {
      let siExiste = false
      lisAutPerfil.forEach((elemento1, _id) => {
        if(elemento.codigoAutorizac===elemento1.codigoAutorizac){
          siExiste = true
        }
      })
      if(siExiste===false){
        lisAut.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
          _id: elemento._id, estadoAut: false});

          lisAutIni.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
          _id: elemento._id, estadoAut: false});
      }
    })

    this.ordenarArrayAsc(lisAut, 'codigoAutorizac')
    this.setState({lisAut})

    this.ordenarArrayAsc(lisAutIni, 'codigoAutorizac')
    this.setState({lisAutIni})
  }

  addAutorizac = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addAutorizac: true})
  }

  addPerfil = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addPerfil: true})
  }

  addUsu = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addUsu: true})
  }

  handleChange = (ev, input)=>{
    console.log(ev.target)
    const argsAdd = this.state.argsAdd
    let file = "", archivoFirma = ""
    if(ev.target.name==='file'){
      if(ev.target.files[0]){
        file = ev.target.files[0]
        archivoFirma = ev.target.files[0].name
      }
    }else{
      if(this.state.addUsu){
      }
      argsAdd[ev.target.name] = ev.target.value
    }
    argsAdd['archivoFirma'] = archivoFirma
    argsAdd['file'] = file
    this.setState({argsAdd});
  }

  crudBD = async (operacionCRUD, args, i)=>{
    // console.log("CRUD")
        if(args.ctrlCampo === 'CRUD'){
  // console.log(i)
  // console.log(args)
          const {data} = await operacionCRUD({
            variables: args
          });
    
    //Se utiliza para traer el _id del documento creado
          if(args.ctrl_id === 'SI_ID'){
            if(Object.values(data)[0]._id){
              return Object.values(data)[0]._id
            }else{
              return 0
            }
          }
        }else{
          if(args.ctrlCampo === "MANY"){
            // console.log("MANY")
            // console.log(args)
            const {data} = await operacionCRUD({
              variables: args
            });
          }
        }
      }

      updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
  // console.log(argsCrud)
  // console.log(totDocCRUD)
        let codigo = 0
        // console.log(argsCrud)
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
        }else{
          await this.crudBD(crudColecc[0], argsCrud[0], 0)
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
  // console.log("inicio")
        for(let i=1; i<totDocCRUD; i++){
          await this.crudBD(crudColecc[i], argsCrud[i], i)
        }
  console.log("final")
      }

      
  handleAutorizac = async (ev, args)=>{
    if(!args.codigoAutorizac||!args.descrAutorizac){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoAutorizac){
        argsAdd['codigoAutorizac'] = "";
        errors.push({path: 'codigoAutorizac', message: "Debe escribir el código"});
      }
      if(!args.descrAutorizac){
        argsAdd['descrAutorizac'] = "";
        errors.push({path: 'descrAutorizac', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addAutorizac){
        const response = await this.props.createAutorizac({
          variables: args
        });
        const {errors, success} = response.data.createAutorizac;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoAutorizac = document.getElementById("codigoAutorizac");
          var descrAutorizac = document.getElementById("descrAutorizac");
          codigoAutorizac.value = ""
          descrAutorizac.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allAutorizac.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrAutorizac: args.descrAutorizac
          }
          const response = await this.props.editAutorizac({
            variables: argsUpd
          });
          const {errors, success} = response.data.editAutorizac;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allAutorizac.refetch()
            this.estadosFalse()
            this.setState({showAutorizac: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteAutorizac({
            variables: argsDel
          });
          this.props.allAutorizac.refetch()
          this.estadosFalse()
          this.setState({showAutorizac: true})
        }
      }
    }
  }

  handlePerfil = async (ev, args)=>{
    if(!args.descrPerfil){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrPerfil){
        argsAdd['descrPerfil'] = "";
        errors.push({path: 'descrPerfil', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addPerfil){
        const response = await this.props.createPerfil({
          variables: args
        });
        const {errors, success} = response.data.createPerfil;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrPerfil = document.getElementById("descrPerfil");
          descrPerfil.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allPerfiles.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrPerfil: args.descrPerfil
          }
          const response = await this.props.editPerfil({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPerfil;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allPerfiles.refetch()
            this.estadosFalse()
            this.setState({showPerfil: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deletePerfil({
            variables: argsDel
          });
          this.props.allPerfiles.refetch()
          this.estadosFalse()
          this.setState({showPerfil: true})
        }
      }
    }
  }

  handlePerfilAut = async (ev, args)=>{
    const errors = [];

    args.forEach((elemento, _id) => {
      if(elemento.estadoAut===false){
        errors.push({path: 'Autorización', message: `La autorización ${elemento.descrAutorizac} esta seleccionado para quitar`});
      }
    })
    if(errors.length>0){
      this.setState({errorAdd: errors})
    }
      if(errors.length===0){
        let arrayAutPerfilIni=this.state.lisAutPerfilIni
        const arrayServ = this.props.allAutorizac.allAutorizac
        let argsUpd, argsDel
        
        let actColecc = [], creaColecc = []

        args.forEach((elemento, _id) => {
          let siExiste = false
          arrayAutPerfilIni.forEach((elemento1, _id) => {
            if(elemento.codigoAutorizac===elemento1.codigoAutorizac){
              siExiste = true
            }
          })
          if(siExiste===false){
            arrayServ.forEach((elemento2, _id) => {
              if(elemento.codigoAutorizac===elemento2.codigoAutorizac){
                argsUpd = {
                  "tipoAct": "EditarAutorizac",
                  "_id": this.state.idLista._id,
                  "codigoAutorizac" : elemento2.codigoAutorizac,
                  "descrAutorizac" : elemento2.descrAutorizac,
                };
                creaColecc.push(argsUpd)
              }
            })
          }
        })

        arrayAutPerfilIni.forEach((elemento, _id) => {
          let siExiste = false
          args.forEach((elemento1, _id) => {
            if(elemento.codigoAutorizac===elemento1.codigoAutorizac){
              siExiste = true
            }
          })
          if(siExiste===false){
            argsDel = {
              "tipoAct": "EliminarAutorizac",
              "_id": this.state.idLista._id,
              "codigoAutorizac": elemento.codigoAutorizac,
            };
            actColecc.push(argsDel)
          }
        })

        let numDocCRUD = 0
        let totDocCRUD = creaColecc.length + actColecc.length
        let argsCrud = [], crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editPerfilUpdDoc)
        }
        creaColecc.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

          numDocCRUD += 1
        })

        actColecc.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  
          numDocCRUD += 1
        })

        if(totDocCRUD>0){
          this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }

        this.props.allPerfiles.refetch()
        this.estadosFalse()
        this.setState({showPerfil: true})
      }
    // }
  }

  handleUsuario = async (ev, args, nombreUsuarioAnt)=>{
    console.log(args)
  if(!args.email||!args.nombreUsuario||(!args.claveDeAcceso&&this.state.addUsu)||
    (args.email==="slcm@slcm.com"&&this.state.permiteDelete)||
    args.descrPerfil==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(args.email==="slcm@slcm.com"&&this.state.permiteDelete){ 
        argsAdd['slcm'] = "";
        errors.push({path: 'slcm', message: "No es posible eliminar el usuario slcm@slcm.com" });
      }
      if(!args.email){
        argsAdd['email'] = "";
        errors.push({path: 'email', message: "Debe escribir el correo electrónico"});
      }
      if(!args.nombreUsuario){
        argsAdd['nombreUsuario'] = "";
        errors.push({path: 'nombreUsuario', message: "Debe escribir el nombre del usuario"});
      }
      if(!args.claveDeAcceso){
          argsAdd['claveDeAcceso'] = "";
          errors.push({path: 'Clave de acceso', message: "Debe escribir la clave de acceso"});
      }
      if(!args.descrPerfil||args.descrPerfil==="Seleccionar..."){
        argsAdd['_id'] = "";
        argsAdd['descrPerfil'] = "Seleccionar...";
        errors.push({path: 'Perfil', message: "Debe seleccionar el perfil"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
      
    }else{
      if(this.state.addUsu){
        args.versionMacro=1
        args.estado='Activo'
        if(!args.gestionaHallazgos){
          args.gestionaHallazgos='No'
        }
        if(!args.esLider){
          args.esLider='No'
        }
        if(!args.suLider || (args.suLider && args.suLider==='Seleccionar...')){
          args.suLider=''
        }
        if(args.file!==null && args.file!==''){
          let response = await this.props.singleUpload({variables: {file: args.file}}); 
        }
console.log(args)
        const response = await this.props.createUsuario({
          variables: args
        });
        // console.log("despues")
        const {errors, success} = response.data.createUsuario;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var email = document.getElementById("email");
          var nombreUsuario = document.getElementById("nombreUsuario");
          var claveDeAcceso = document.getElementById("claveDeAcceso");
          var perfil = document.getElementById("miLista");
          var tipo = document.getElementById("miLista1");
          var gestionaHallazgos = document.getElementById("miLista3");
          var descrEmpresa = document.getElementById("miListaE");
          var esLider = document.getElementById("miLista4");
          var suLider = document.getElementById("miListaU");
          var cedula = document.getElementById("cedula");
          var ciudad = document.getElementById("ciudad");
          var cargo = document.getElementById("cargo");
          var telefono = document.getElementById("telefono");
          perfil.options.selectedIndex = 0
          descrEmpresa.options.selectedIndex = 0
          gestionaHallazgos.options.selectedIndex = 0
          suLider.options.selectedIndex = 0
          esLider.options.selectedIndex = 0
          email.value = ""
          nombreUsuario.value = ""
          claveDeAcceso.value = ""
          cedula = ""
          ciudad = ""
          cargo = "" 
          telefono = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allUsuarios.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          console.log(args)
          const argsUpd = {
            _id: args._id,
            tipoAct: "EditarUsu",
            nombreUsuario: args.nombreUsuario,
            nombreUsuarioAnt: nombreUsuarioAnt,            
            idPerfil: args.idPerfil,
            descrPerfil: args.descrPerfil,
            descrEmpresa: args.descrEmpresa,
            versionMacro: 1,
            tipo: args.tipo,
            cedula: args.cedula,
            ciudad: args.ciudad,
            cargo: args.cargo,
            telefono: args.telefono,
            gestionaHallazgos: args.gestionaHallazgos,
            estado: args.estado,
            archivoFirma: args.archivoFirma,
            modFirma: 'N',
            esLider: args.esLider,
            suLider: args.suLider,
          }
          console.log(argsUpd)

          if(args.file && args.file!==null && args.file!==''){
            argsUpd.modFirma = 'S'
            console.log(argsUpd)
            let response = await this.props.singleUpload({variables: {file: args.file}}); 
          }
          console.log(argsUpd)
          const response = await this.props.editUsuario({
            variables: argsUpd
          });
          const {errors, success} = response.data.editUsuario;
          if (!success){
            this.setState({errorAdd: errors})
            
          }else{
            this.props.allUsuarios.refetch()
            this.estadosFalse()
            this.setState({showUsu: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteUsuario({
            variables: argsDel
          });
          this.props.allUsuarios.refetch()

          this.estadosFalse()
          this.setState({showUsu: true})
        }
      }
    }
  }

  handleCambClave = async (ev, args, usuActivo)=>{
    const argsAdd = this.state.argsAdd
    const errors = [];

    if(!args.claveDeAccesoAct||!args.claveDeAccesoNva1||!args.claveDeAccesoNva2||errors.length>0||
      args.claveDeAccesoNva1!==args.claveDeAccesoNva2||args.claveDeAccesoNva1.length<6){
      if(!args.claveDeAccesoAct){
        errors.push({path: 'Clave de acceso', message: "Debe escribir la clave de acceso ACTUAL"});
      }
      if(!args.claveDeAccesoNva1){
        errors.push({path: 'Clave de acceso', message: "Debe escribir la NUEVA clave de acceso"});
      }else{
        if(args.claveDeAccesoNva1.length<6){
          errors.push({path: 'Clave de acceso', message: "La clave debe ser mayor o igual a 6 caracteres"});
        }
      }
      if(!args.claveDeAccesoNva2){
        errors.push({path: 'Clave de acceso', message: "Debe repetir la NUEVA clave de acceso"});
      }
      if(args.claveDeAccesoNva1!==args.claveDeAccesoNva2){
        errors.push({path: 'Clave de acceso', message: "La NUEVA clave de acceso no coincide al repetirla"});
      }

      this.setState({argsAdd});
      this.setState({errorAdd: errors})

    }else{
      const argsUpd = {
        email: localStorage.getItem('userLogin'),
        claveDeAcceso: args.claveDeAccesoAct
      }
      const response = await this.props.login({
        variables: argsUpd
      });
      const {success} = response.data.login
      // console.log(token)
      if(!success){
        argsAdd['claveDeAccesoAct'] = "";
        errors.push({path: 'Clave de acceso', message: "Clave de acceso ACTUAL no es válida"});

        this.setState({argsAdd});
        this.setState({errorAdd: errors})
      }else{
      const argsUpd = {
        _id: usuActivo._id,
        tipoAct: "EditarClave",
        claveDeAcceso: args.claveDeAccesoNva1,
      }
      const response = await this.props.editUsuario({
        variables: argsUpd
      });
      const {errors, success} = response.data.editUsuario;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        var claveDeAccesoAct = document.getElementById("claveDeAccesoAct");
        var claveDeAccesoNva1 = document.getElementById("claveDeAccesoNva1");
        var claveDeAccesoNva2 = document.getElementById("claveDeAccesoNva2");
        claveDeAccesoAct.value = ""
        claveDeAccesoNva1.value = ""
        claveDeAccesoNva2.value = ""
        this.setState({errorAdd: []})
      }
      // }else{
        this.props.allUsuarios.refetch()
        // this.estadosFalse()
        // this.setState({showCambClave: true})
      // }
      }
    }
  }

  showDescUsuario = async () => {
    let {data} = await this.props.allUsuarios.refetch()
    let usuarios = await data.allUsuarios
    // console.log(estructura)
  
    if(usuarios.length>0){
  //Archivo Excel
      let xlsString = []
      let listRtes = usuarios
      let xlsString1 = []
      xlsString1 = ['Tipo', 'Nombre', 'Empresa', 'Cedula', 'Ciudad', 'Teléfono', 'Cargo', 'Estado', 'Gestiona hallazgos', 'Es lider ?', 'Su lider es:']    
      xlsString.push(xlsString1)
  
      for(let i=0; i<listRtes.length; i++){
        xlsString1 = [listRtes[i].tipo, listRtes[i].nombreUsuario, listRtes[i].descrEmpresa, listRtes[i].cedula,
        listRtes[i].ciudad, listRtes[i].telefono, listRtes[i].cargo, listRtes[i].estado?listRtes[i].estado:'Activo', 
        listRtes[i].gestionaHallazgos?listRtes[i].gestionaHallazgos:'No', listRtes[i].esLider?listRtes[i].esLider:'No',
        listRtes[i].suLider?listRtes[i].suLider:'']
        xlsString.push(xlsString1)
      }
  
      var wb = XLSX.utils.book_new();
  
      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };
  
      wb.SheetNames.push("Usuarios");
  
      let ws_data = xlsString;
  
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Usuarios"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Usuarios.xlsx');
    }
  }


  handleTipo = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['tipo'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }  

  // handleHallazgo = () => {
  //   console.log(this.state.argsAdd)
  //   var miLista = document.getElementById("miLista3");
  //   const argsAdd = this.state.argsAdd
  //   argsAdd['gestionaHallazgos'] = miLista.options[miLista.selectedIndex].text
  //   this.setState({argsAdd});
  //   console.log(this.state.argsAdd)
  // }

  handlePerfilUsu = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrPerfil'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleEmpresa = () => {
    var miLista = document.getElementById("miListaE");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEmpresa'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text==="Todas..."){
      argsAdd['descrEmpresa'] = "Todas..."
    }
    this.setState({argsAdd});
  }

  handleLider = () => {
    var miLista = document.getElementById("miListaU");
    const argsAdd = this.state.argsAdd
    argsAdd['suLider'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
      argsAdd['suLider'] = ""
    }
    this.setState({argsAdd});
  }

  idLista = async (ev, idLista)=>{
    // console.log(idLista)
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showAutorizac) {
      this.setState({verAutorizac: true})
    }
    if (this.state.showPerfil) {
      this.setState({verPerfil: true})
    }
    if (this.state.showUsu) {
      this.setState({verUsu: true})
    }
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: true,
    })
  }

  render(){
    const {showUser, showAutorizac, addAutorizac, verAutorizac,
      showPerfil, addPerfil, verPerfil, showCambClave, showAutPerfil,
      showUsu, addUsu, verUsu, showUpdUsu,
      lisAutPerfil, lisAut, lisAutPerfilIni, lisAutIni,
      permiteUpdate, permiteDelete, argsAdd, errorAdd, idLista} = this.state;        

      console.log(this.state.argsAdd) 
    // console.log(lisAut)
    // console.log(lisAutPerfil)
    let lista = [], lista1 = [], lista2 = []

    if (this.state.showAutorizac) {
      if(this.props.allAutorizac.allAutorizac){lista = this.props.allAutorizac.allAutorizac}
    }
    if (this.state.showPerfil) {
      if(this.props.allPerfiles.allPerfiles){lista = this.props.allPerfiles.allPerfiles}
    }
    if (this.state.showUsu) {
      if(this.props.allUsuarios.allUsuarios){lista = this.props.allUsuarios.allUsuarios}
      console.log(lista)
    }
    if (this.state.addUsu||this.state.verUsu) {
      if(this.state.addUsu){
        console.log(argsAdd)
        if(!argsAdd.descrEmpresa){
          argsAdd['descrEmpresa'] = "Todas..."
        }
        if(!argsAdd.tipo){
          argsAdd['tipo'] = "Administrativo"
        }
        if(!argsAdd.versionMacro){
          argsAdd['versionMacro'] = "1"
        }
        if(!argsAdd.esLider){
          argsAdd['esLider'] = "No"
        }
        if(!argsAdd.suLider){
          argsAdd['suLider'] = "Seleccionar..."
        }
      }
      
      if(this.props.allEmpresa.allEmpresa){
        if(this.props.allEmpresa.allEmpresa){lista1 = this.props.allEmpresa.allEmpresa}
        lista1 = _.orderBy(lista1, ['descrEmpresa'])
      }
      if(this.props.allUsuariosRtes1.allUsuariosRtes){
        if(this.props.allUsuariosRtes1.allUsuariosRtes){lista2 = this.props.allUsuariosRtes1.allUsuariosRtes}
        lista2 = _.orderBy(lista2, ['nombreUsuario'])
      }
      console.log(lista2)
    }
    // console.log(localStorage.getItem('userLogin'))

      let usuActivo = {}
      if(this.props.allUsuarios.allUsuarios){
        usuActivo = this.props.allUsuarios.allUsuarios.filter(usuario => usuario.email===localStorage.getItem('userLogin'))
      }
    
    console.log(argsAdd)
    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showUser && <HomeUser1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickSel1={this.showAutorizac}
                          handleClickSel2={this.showPerfil} handleClickSel3={this.showUsu}
                          handleClickSel4={this.showCambClave}/>}

            {showAutorizac && <UserAut1 styles={this.props.styles} handleClickRegr={this.showUser}/>}
            {addAutorizac && <AddAut1 styles={this.props.styles} handleClickRegr={this.showAutorizac}/>}
            {verAutorizac && <VerAut1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showAutorizac} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showPerfil && <UserPerfil1 styles={this.props.styles} handleClickRegr={this.showUser}/>}
            {addPerfil && <AddPerfil1 styles={this.props.styles} handleClickRegr={this.showPerfil}/>}
            {verPerfil && <VerPerfil1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                          handleClickRegr={this.showPerfil} handleClickUpd={this.handleClickUpd}
                          handleClickDel={this.handleClickDel} handleClickSel1={this.showAutPerfil}/>}

            {showAutPerfil && <UserAutP1 styles={this.props.styles} handleClickRegr={this.showPerfil}/>}

            {showUsu && <UserUsu1 styles={this.props.styles} handleClickSel2={this.showUpdUsu}
                handleClickSel1={this.showDescUsuario} handleClickRegr={this.showUser}/>}
            {addUsu && <AddUsu1 styles={this.props.styles} handleClickRegr={this.showUsu}/>}
            {verUsu && <VerUsu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showUsu} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showCambClave && <CambClave1 styles={this.props.styles} handleClickRegr={this.showUser}/>}
            {showUpdUsu && <CargUsu1 styles={this.props.styles} handleClickRegr={this.showUsu}/>}

          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showUser && <HomeUser2 styles={this.props.styles}/>}

            {showAutorizac && <UserAut2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addAutorizac} list={lista} handleClickidLista={this.idLista}/>}
            {addAutorizac && <AddAut2 styles={this.props.styles} handleSubmit={this.handleAutorizac} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verAutorizac && <VerAut2 styles={this.props.styles} handleSubmit={this.handleAutorizac} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showPerfil && <UserPerfil2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addPerfil} list={lista} handleClickidLista={this.idLista}/>}
            {addPerfil && <AddPerfil2 styles={this.props.styles} handleSubmit={this.handlePerfil} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verPerfil && <VerPerfil2 styles={this.props.styles} handleSubmit={this.handlePerfil} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete} handleClickSel1={this.showAutPerfil}/>}

            {showAutPerfil && <UserAutP2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                lisAutPerfil={lisAutPerfil} lisAut={lisAut} lisAutIni={lisAutIni} lisAutPerfilIni={lisAutPerfilIni} handleVrinic={this.showAutPerfil} perfil={idLista.descrPerfil} errors={errorAdd} handleSubmit={this.handlePerfilAut}/>}

            {showUsu && <UserUsu2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addUsu} list={lista} handleClickidLista={this.idLista}/>}
            {addUsu && <AddUsu2 styles={this.props.styles} handleSubmit={this.handleUsuario}
              handleListaT={this.handleTipo} handleLista={this.handlePerfilUsu} handleListaL={this.handleEsLider} handleListaU={this.handleLider}    
              handleListaC={this.handleEmpresa}  handleListaH={this.handleHallazgo}  handleChange={this.handleChange} 
              args={argsAdd} errors={errorAdd} list1={lista1} list2={lista2} />}
            {verUsu && <VerUsu2 styles={this.props.styles} handleSubmit={this.handleUsuario}
              handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista}
              permiteUpdate={permiteUpdate} permiteDelete={permiteDelete} list1={lista1} list2={lista2}/>}

            {showCambClave && <CambClave2 styles={this.props.styles} usuActivo={usuActivo} handleSubmit={this.handleCambClave} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} handleClickRegr={this.showUser}/>}
            {showUpdUsu && <CargUsu2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allAutorizac, {name:'allAutorizac', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createAutorizac, {name:'createAutorizac'}),
  graphql(queries.mutation.editAutorizac, {name:'editAutorizac'}),
  graphql(queries.mutation.deleteAutorizac, {name:'deleteAutorizac'}),

  graphql(queries.query.allPerfiles, {name:'allPerfiles', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createPerfil, {name:'createPerfil'}),
  graphql(queries.mutation.editPerfil, {name:'editPerfil'}),
  graphql(queries.mutation.editPerfilUpdDoc, {name:'editPerfilUpdDoc'}),
  graphql(queries.mutation.deletePerfil, {name:'deletePerfil'}),

  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {versionMacro: {$gt: 0}}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {esLider: 'Si'}}]`}}}}),
  
  graphql(queries.mutation.createUsuario, {name:'createUsuario'}),
  graphql(queries.mutation.editUsuario, {name:'editUsuario'}),
  graphql(queries.mutation.deleteUsuario, {name:'deleteUsuario'}),

  graphql(queries.mutation.login, {name:'login'}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),

  // graphql(queries.query.allPagoClientes, {name:'allPagoClientes', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  // graphql(queries.mutation.editPagoClientesUpdDoc, {name:'editPagoClientesUpdDoc'}),

  // graphql(queries.query.allDetalleDX, {name:'allDetalleDX', options: (props) => {return {variables: {numeroOdeDX: 4}}}}),
  // graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),

  // graphql(queries.query.allOdeSRtes, {name:'allOdeSRtes', options: (props) => {return {variables: argsBuscarOS}}}),
  // graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {}}}}),
  // graphql(queries.mutation.createFacturacionMany, {name:'createFacturacionMany'}),
  // graphql(queries.mutation.deleteFacturacion, {name:'deleteFacturacion'}),
  
  )(HomeUser)
